import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { PuntoEntregaModel } from '../../../models/puntoEntregaModel';
import { empModulo } from '../../../diccionarios/empModulo';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component'; 
import { takeWhile, throwIfEmpty } from 'rxjs/operators';
import { UsuarioService } from 'src/app/shared-module/admin-seguridad/services/usuario.service';
import { CatalogoService } from 'src/app/aplicaciones-modulos/epp/services/catalogo.service';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';
import { EmpleadoModel } from '../../../models/empleadoModel';
import { EmpresasModel } from '../../../models/empresasModel';
import { ProvinciasModel } from '../../../models/provinciaModel';
import { CantonesModel } from '../../../models/cantonesModel';
import { CaracteristicaModel } from '../../../models/caracteristicaModel';


@Component({
  selector: 'app-ce-empleado',
  templateUrl: './ce-empleado.component.html',
  styleUrls: ['./ce-empleado.component.css']
})
export class CrearEmpleadoComponent implements OnInit {
  textoBuscar: string;
  resposiveFull: string;
  empModulo: any = {};
  errorTelefono = false;
  loguedUser: string = "";
  cedulaEmpleado: string = "";
  formulario: FormGroup;
  currentDate = new Date();
  cmbEmpresa: EmpresasModel[] = [];
  mainEmpresa: EmpresasModel = new EmpresasModel();
  cmbProvincias: ProvinciasModel[] = [];
  mainProvincia: ProvinciasModel;
  cmbCantones: CantonesModel[] = [];
  mainCanton: string = "";
  cmbCargos: CaracteristicaModel[] = [];
  mainCargo: CaracteristicaModel = new CaracteristicaModel();
  cmbOrientacion: any[] = [];
  cmbEstadoCivil: any[] = [];
  cmbRegion: any[] = [];
  cmbDepartamento: CaracteristicaModel[] = [];
  mainDepartamento: CaracteristicaModel = new CaracteristicaModel();
  cmbCodigoCosto: CaracteristicaModel[] = [];
  mainCodigoCosto: CaracteristicaModel = new CaracteristicaModel();
  cmbLocalidad: any[];
  mainLocalidad: CaracteristicaModel;

  cmbTipoEmpleado: any[] = [];
  cmbEmpresaSolicita: EmpresasModel[] = [];
  mainEmpresaSolicita: EmpresasModel = new EmpresasModel();
  cmbDepartamentoSolicita: CaracteristicaModel[] = [];
  mainDepartamentoSolicita: CaracteristicaModel = new CaracteristicaModel();
  cmbEmpleadoSolicita: any[] = [];
  mainEmpleadoSolicita: string;

  falsoPositivo: boolean = false;

  nuevoUsuario: number = 1;
  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  sendObject: any = {};

  loading: boolean = false;
  listaVacia: boolean = true;
  // dataEdit: PuntoEntregaModel;
  // banderaEdit: boolean = false;

  // titulo:string = 'Crear Punto de Entrega';
  mostrarFormulario: boolean = false;

  columnDefsUser: any[];
  rowDataUser: any[] = [];
  frameworkComponentsEmpresas: any;
  gridApiUser: any;
  gridColumnApiUser: any;
  rowSelectionUser: any;

  loadingUsuario: boolean;
  listaVaciaUsuarios: boolean;
  textoBuscarUser: any;
  cmbTipo: any[] = [];

  columnDefsPe: any[];
  rowDataPe: any[] = [];
  frameworkComponentsPe: any;
  gridApiPe: any;
  gridColumnApiPe: any;
  rowSelectionPe: any;
  loadingPe: boolean;
  listaVaciaPe: boolean = true;
  dataEdit: any = {};
  title: string = '';

  codEmpresa: any = {};
  claseLabel: string = '';
  depSolicita: string = 'Departamento Solicita';
  empSolicitante: string = 'Empleado Solicitante';
  isIES: string = '';
  documentoIess: boolean = false; 
  statusCheck: string = "";

  check: HTMLInputElement;

  constructor(private fb: FormBuilder, private _util: UtilsService, private _catalogo: CatalogoService,
    private _crearEmpleado: CrearEmpleadoService, private _usuarios: UsuarioService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.cmbTipo = this._catalogo.catalogoTipo();
    this.formulario = this.fb.group({
      cedula: ['', [Validators.required,Validators.maxLength(10)]],
      email: ['', [Validators.email]],
      nombres: ['', [Validators.required]],
      fechaNacimiento: ['', [Validators.required]],
      localidad: ['', [Validators.required]],
      empresa: ['', [Validators.required]],
      cargo: ['', [Validators.required]],
      areaTrabajo: [''],
      //estadoCivil: ['',[Validators.required]],
      pais: ['', [Validators.required]],
      provincia: [''],
      canton: [''],
      direccion: [''],
      genero: [''],
      regionDomi: [''],
      codCosto: [''],
      reportaA: ['',],
      fechaPrimero: [''],
      fechaUltimo: [''],
      fechaIngreso: ['', [Validators.required]],
      fechaSalida: ['', [Validators.required]],
      telefono: [''/*,[Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]+')]*/],
      tipoEmpleado: ['', [Validators.required]],
      empresaSolicita: ['', [Validators.required]],
      departamentoSolicita: [''],//[Validators.required]],
      empleadoSolicita: [''],//[Validators.required]],
      motivoVisita: [''],
      IESS: [''], //descomentar para la nueva version q hay q subir
      documentoIess: [''],
      cedulaNacional: [true],
    });
    this.documentoIess = false;
    this.formulario.get('documentoIess').setValue(this.documentoIess);
    this.getAllEmpresas();
    this.getAllProvincias();
    this.getAllCargos();
    this.getGeneros();
    this.getEstadosCivil();
    this.getRegion();
    this.getAllCodigoCostos();
    this.getAllDepartamento();
    this.getAllLocalidads();
    this.getTipoEmpleado();
    this.getAllEmpresaSolicita();
    this.codEmpresa = this._catalogo.getCodEmpreFabril();
    this.loguedUser = localStorage.getItem('userName');
    this.formulario.get('fechaPrimero').setValue(null);
    this.formulario.get('fechaUltimo').setValue(null);
    this.formulario.get('pais').setValue('ECUADOR');
    setTimeout(() => {
      this.check = document.getElementById("documentoIess") as HTMLInputElement;
      this.check.checked = false;
      this.statusCheck = "";
    }, 200);
  }

  setCheckForm(value) {
    if(value){
      this.documentoIess = false;
      this.statusCheck = "";
      this.check.checked = false;
    } else {
      this.documentoIess = true;
      this.statusCheck = "Activo";
      this.check.checked = true;
    }
    this.formulario.get('documentoIess').setValue(this.documentoIess);
  }

  // setCheckForm(value) {
  //   this.documentoIess = (value)? false: true;
  //   this.statusCheck = (value)? "": "Activo";
  //   this.formulario.get('documentoIess').setValue(this.documentoIess);
  // }

  keyPress(event) {
    let text: string = this.formulario.get('nombres').value;
    if(text.length > 0) {
      text = text.replace('\t',' ');
      text = text.replace(/  +/g, ' ');
      this.formulario.get('nombres').setValue(text);
    }
  }

  limpiarFormulario() {
    let checkCedula = this.formulario.get('cedulaNacional').value;

    this.formulario.reset();
    this.formulario.get('cedula').setValue(this.cedulaEmpleado);
    this.documentoIess = false;
    this.formulario.get('documentoIess').setValue(this.documentoIess);
    this.check.checked = false;
    this.statusCheck = "";
    
    this.formulario.get('cedulaNacional').setValue(checkCedula);
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChangedUser() {
    this.gridApiUser.setQuickFilter(this.textoBuscarUser);
  }

  onGridReadyUser(params) {
    this.gridApiUser = params.api;
    this.gridColumnApiUser = params.columnApi;
  }

  onQuickFilterChangedPe() {
    //this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReadyPe(params) {
    this.gridApiPe = params.api;
    this.gridColumnApiPe = params.columnApi;
  }


  onValidacionCelular(event) {
    // debugger
    this.errorTelefono = false;
    let telefono = this.formulario.get('telefono').value;
    telefono = telefono.substring(0, 1);
    if (telefono != 0) {
      this.formulario.get('telefono').setErrors({ incorrect: true });
      this.errorTelefono = true;
    }
  }

  agregar({ rowData }) {
    //this.formulario.get('cidEmpleado').setValue(rowData.login);
    this.mainEmpresa = rowData.codEmpresa;
    document.getElementById('cerrarModal').click();
  }

  callModal() {
    document.getElementById('abrirModal').click();
  }

  regresar() {
    this.mostrarFormulario = false;
    this.formulario.reset();
    this.rowDataPe = [];
    this.dataEdit = {};
  }

  guardarForm() {
    let data = this.formulario.value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea asignar el siguiente colaborador?',
        text: '',
        action: 'Asignar',
        //funcion: this._crearEmpleado.postAsignacion(data),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      //this.getAsignacion(this.dataEdit.id);
      this.formulario.get('tipo').setValue('');
      this.formulario.get('cidEmpleado').setValue('');
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message);
    });
  }


  getAllEmpresas() {
    this._crearEmpleado.getAllEmpresas().subscribe((res: any) => {
      this.cmbEmpresa = res.sort((a, b) => a.descripcion.localeCompare(b.descripcion));;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se ecnontro al empleado');
      //this._util.mensajeErrorVisto(err.error.message);
    });

  }

  getAllEmpresaSolicita() {
    this._crearEmpleado.getAllEmpresaSolicita().subscribe((res: any) => {
      this.cmbEmpresaSolicita = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se ecnontro al empleado');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  seleccionEmpresa() {
    //this.formulario.get('empresa').setValue(this.mainEmpresa.descripcion);
    this.mainEmpresa = this.findCmbGenericArray(this.cmbEmpresa, this.formulario.get('empresa').value);
  }

  selecionEmpresaSolicita() {
    this.changeEmpresaSolicita();
    // this.formulario.get('departamentoSolicita').setValue('');
    // this.formulario.get('empleadoSolicita').setValue('');
    this.cmbDepartamentoSolicita = [];
    this.cmbEmpleadoSolicita = [];
    this.mainEmpresaSolicita = this.findCmbGenericArray(this.cmbEmpresa, this.formulario.get('empresaSolicita').value);
    if(this.mainEmpresaSolicita.codEmpresa !== undefined){
      this._crearEmpleado.getDepartamentoByEmpresa(this.mainEmpresaSolicita.codEmpresa).subscribe((res: any) => {
        res.map(e => {e.descripcion = e.codigo + ' - ' + e.descripcion;});  
        this.cmbDepartamentoSolicita = res;
        this.getAllEmpleadoEmpresa();
        if(this.cmbDepartamentoSolicita.length === 0) {
          this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
        }
      }, (err) => {
        this.cmbDepartamentoSolicita = [];
        this.getAllEmpleadoEmpresa();
        this._util.mensajeErroToast('No se encontró al Departamento a partir de la empresa', 3000);
        console.log(err);
        console.log('No se encontró al Departamento a partir de la empresa');
      });
    }
  }

  getAllEmpleadoEmpresa() {
    // debugger
    this.mainEmpresaSolicita = this.findCmbGenericArray(this.cmbEmpresa, this.formulario.get('empresaSolicita').value);
    this._crearEmpleado.empleadoEmpresaColaborador(this.mainEmpresaSolicita.codEmpresa).subscribe((res:any)=>{
    // this._crearEmpleado.getAllEmpleadoEmpresa(this.mainEmpresaSolicita.codEmpresa).subscribe((res:any)=>{
      this.cmbEmpleadoSolicita = res;
    },(err:any)=>{
      this.cmbEmpleadoSolicita = [];
    });
  }

  selecionDepartamentoSolicita() {
    this.mainDepartamentoSolicita = this.findCmbGeneralValueDesc(this.cmbDepartamento, this.formulario.get('departamentoSolicita').value);
    this._crearEmpleado.getEmployesByDepEmpColaborador(this.mainDepartamentoSolicita.codigo, this.mainEmpresaSolicita.codEmpresa).subscribe((res: any) => {
    // this._crearEmpleado.getEmpleadosByDepAndEmp(this.mainDepartamentoSolicita.pk.codigo, this.mainEmpresaSolicita.codEmpresa).subscribe((res: any) => {
      this.cmbEmpleadoSolicita = res;
    }, (err) => {
      this.cmbEmpleadoSolicita = [];
      console.log(err);
      console.log('No se encontro Empleados a partir de la empresa y departamento');
    });
  }

  selecionEmpleadoSolicita() {
    this.mainEmpleadoSolicita = this.formulario.get('empleadoSolicita').value;
  }

  getAllCodigoCostos() {
    this._crearEmpleado.getAllCodigoCostos().subscribe((res: any) => {
      this.cmbCodigoCosto = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se encontró los codigos de Costos');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  selecionCodigoCosto() {
    this.mainCodigoCosto = this.findCmbGeneralValueDesc(this.cmbCodigoCosto, this.formulario.get('codCosto').value);
    this.formulario.get('codCosto').setValue(this.mainCodigoCosto.descripcion);
  }

  getAllLocalidads() {
    this._crearEmpleado.getAllLocalidades().subscribe((res: any) => {
      this.cmbLocalidad = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se encontro las localidades');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  seleccionLocalidad() {
    this.mainLocalidad = this.findCmbGeneralValueDesc(this.cmbLocalidad, this.formulario.get('localidad').value);
    this.formulario.get('localidad').setValue(this.mainLocalidad.descripcion);
  }

  getAllDepartamento() {
    this._crearEmpleado.getAllDepartamentos().subscribe((res: any) => {
      res.map(e => {e.descripcion = e.codigo + ' - ' + e.descripcion;});  
      this.cmbDepartamento = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se encontro los departamentos');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  selectionDepartamento() {
    this.mainDepartamento = this.findCmbGeneralValueDesc(this.cmbDepartamento, this.formulario.get('areaTrabajo').value);
    this.formulario.get('areaTrabajo').setValue(this.mainDepartamento.descripcion);

  }

  getAllProvincias() {
    this._crearEmpleado.getAllProvincias().subscribe((res: any) => {
      this.cmbProvincias = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se ecnontro al empleado');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  selecionProvincias() {
    this.cmbProvincias.forEach(element => {
      if (element.nombre == this.formulario.get('provincia').value) {
        this._crearEmpleado.getCantones(element.codigoProvincia.toString()).subscribe((respuesta) => {
          this.cmbCantones = respuesta;
        });
      }
    });
  }

  selecionCanton() {
    this.formulario.get('canton').value;
  }

  getAllCargos() {
    this._crearEmpleado.getAllCargos().subscribe((res: any) => {
      res.map(e => {e.descripcion = e.codigo + ' - ' + e.descripcion;});  
      this.cmbCargos = res;
    }, (err) => {
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      console.log(err);
      console.log('No se ecnontro al empleado');
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }
  selecionCargo() {
    this.mainCargo = this.findCmbGeneralValueDesc(this.cmbCargos, this.formulario.get('cargo').value);
    this.formulario.get('cargo').setValue(this.mainCargo.descripcion);

  }

  validateUser() {
    // console.log(this.formulario.get('cedula').value);
    this.cedulaEmpleado = this.formulario.get('cedula').value;
    this.limpiarFormulario();
    
    //Valida Cedula nacional
    //let validaCedulaNacional = this.validaCedulaNacional(this.cedulaEmpleado);
    if(this.validaCedulaNacional(this.cedulaEmpleado)) return;

    this._crearEmpleado.validateCedula(this.formulario.get('cedula').value).subscribe((res: any) => {
    }, (err) => {
        this._util.alertifyToast(err.error.mensaje);
    });
    this._crearEmpleado.findEmpleados(this.formulario.get('cedula').value).subscribe((res: any) => {
      if (Object.entries(res).length === 0) {
        console.log('No se encontro al empleado');
        this.falsoPositivo = true;
        //this.banderaArticulo = false;
      } else {
        console.log('Se ecnontro al empleado');
        this.falsoPositivo = false;
        if (res.nombres === undefined) {
          this.falsoPositivo = true;
        }
        this.llenarAtributosEmpleado(res);
        // this.banderaArticulo = true;
      }
    }, (err) => {
      this.falsoPositivo = true;
      //this.banderaArticulo = false;
      //this.nameArticulo = 'No se encontro el articulo';
      //console.log(err);
      console.log(err.error);
      if (err.error.key == 500) {
        console.log('Es un error')
        this._util.mensajeErrorVisto(err.error.status, true, 10000);
        if (err.error.respuesta != undefined) {
          this.llenarAtributosEmpleado(err.error.respuesta);
        }
      }
      console.log('No se ecnontro al empleado');
      this.nuevoUsuario = 1;
      //this._util.mensajeErrorVisto(err.error.message);
    });
  }

  getGeneros() {
    this.cmbOrientacion = this._catalogo.getSexo();
  }

  selecionGenero() {
    this.formulario.get('genero').value;
  }

  getEstadosCivil() {
    this.cmbEstadoCivil = this._catalogo.getEstadoCivil();
  }

  selecionEstadoCivil() {
    this.formulario.get('estadoCivil').value;
  }

  getRegion() {
    this.cmbRegion = this._catalogo.getRegion();
  }

  selecionRegion() {
    this.formulario.get('regionDomi').value;
  }

  getTipoEmpleado() {
    this.cmbTipoEmpleado = this._catalogo.getTipoColaborador();
  }

  llenarAtributosEmpleado(emp: EmpleadoModel) {
    // this.formulario.get('departamentoSolicita').setValue('0');
    // this.formulario.get('empleadoSolicita').setValue('0');
    // this.formulario.get('departamentoSolicita').setValue('');
    // this.formulario.get('empleadoSolicita').setValue('');
    this.nuevoUsuario = 0;
    //console.log(emp);
    this.formulario.get('email').setValue(emp.email);

    this.sendObject.nombres = emp.nombres;
    this.formulario.get('nombres').setValue(emp.nombres);

    if (emp.fechaNacimiento != undefined) {
      this.formulario.get('fechaNacimiento').setValue(emp.fechaNacimiento);
      this.sendObject.fechaNacimiento = emp.fechaNacimiento;
    } else {
      // this.formulario.get('fechaNacimiento').setValue(this.obtenerFechaConversion(this.currentDate));
      this.formulario.get('fechaNacimiento').setValue('');
    }
    if (emp.fechaPrimerContrato != undefined) {
      this.formulario.get('fechaPrimero').setValue(emp.fechaPrimerContrato);
      this.sendObject.fechaPrimerContrato = emp.fechaPrimerContrato;
    }
    if (emp.fechaIngreso != undefined) {
      this.formulario.get('fechaIngreso').setValue(emp.fechaIngreso);
    }
    if (emp.fechaSalida != undefined) {
      this.formulario.get('fechaSalida').setValue(emp.fechaSalida);
    }
    if (emp.fechaUltimoContrato != undefined) {
      this.formulario.get('fechaUltimo').setValue(emp.fechaUltimoContrato);
      this.sendObject.fechaUltimoContrato = emp.fechaUltimoContrato;
    }
    if (emp.telefono != undefined) {
      this.formulario.get('telefono').setValue(emp.telefono);
    }
    this.mainLocalidad = this.findCmbGeneralValueDesc(this.cmbLocalidad, emp.dscaLocalidad);
    this.formulario.get('localidad').setValue(this.mainLocalidad.descripcion);
    //this.formulario.get('estadoCivil').setValue(this.findCmbGenericArray(this.cmbEstadoCivil,emp.estadocivil));
    if (emp.empresa != undefined) {
      this.mainEmpresa = this.findCmbGenericArray(this.cmbEmpresa, emp.empresa.descripcion);
      this.formulario.get('empresa').setValue(this.mainEmpresa.descripcion);
    }
    if (emp.empresaSolicita != undefined) {
      this.cmbEmpresaSolicita.forEach(element => {
        if (element.codEmpresa == emp.empresaSolicita) {
          //console.log(element);
          this.formulario.get('empresaSolicita').setValue(element.descripcion);
          this.mainEmpresaSolicita = element;
          this._crearEmpleado.getDepartamentoByEmpresa(this.mainEmpresaSolicita.codEmpresa).subscribe((res: any) => {
            this.cmbDepartamentoSolicita = res;
            if (emp.departamentoSolicita != undefined) {
              this.mainDepartamentoSolicita = this.findCmbGeneralValueCodigo(this.cmbDepartamentoSolicita, emp.departamentoSolicita);
              this.formulario.get('departamentoSolicita').setValue(this.mainDepartamentoSolicita.descripcion);
              if (emp.empleadoSolicita != undefined) {
                this._crearEmpleado.getEmpleadosByDepAndEmp(this.mainDepartamentoSolicita.codigo, this.mainEmpresaSolicita.codEmpresa).subscribe((res: any) => {
                  this.cmbEmpleadoSolicita = res;
                  this.cmbEmpleadoSolicita.forEach(element => {
                    //console.log(element.pk.codigo +'  '+emp.departamentoSolicita);
                    if (element.cedula == emp.empleadoSolicita) {
                      // console.log(element);
                      //console.log('SE ENCONTRO ELEMENTo');
                      this.formulario.get('empleadoSolicita').setValue(element.cedula);
                      this.mainEmpleadoSolicita = emp.empleadoSolicita;
                    }
                  });
                }, (err) => {
                  console.log(err);
                  console.log('No se encontro Empleados a partir de la empresa y departamento');
                });
              }
            }
          }, (err) => {
            console.log(err);
            console.log('No se ecnontro al Departamento a partir de la empresa');
          });

        }
      });
    }
    /*if(emp.departamentoSolicita != undefined){
      this.cmbDepartamentoSolicita.forEach(element => {
        console.log(element.pk.codigo +'  '+emp.departamentoSolicita);
        if(element.pk.codigo == emp.departamentoSolicita){
          console.log(element);
          console.log('SE ENCONTRO ELEMENTo');
          this.formulario.get('empresaSolicita').setValue(element.descripcion);
          this.mainDepartamentoSolicita = element;
        }
      });
      
      //this.mainDepartamentoSolicita = emp.departamentoSolicita;
    }*/

    if (emp.empleadoSolicita != undefined) {
      this.mainEmpleadoSolicita = emp.empleadoSolicita;
    }
    this.mainCargo = this.findCmbGeneralValueCodigo(this.cmbCargos, emp.codCargo);
    this.formulario.get('cargo').setValue(this.mainCargo.descripcion);
    this.mainDepartamento = this.findCmbGeneralValueCodigo(this.cmbDepartamento, emp.codDepartamento);
    this.formulario.get('areaTrabajo').setValue(this.mainDepartamento.descripcion);
    this.formulario.get('pais').setValue(emp.paisNacimiento);
    this.cmbProvincias.forEach(element => {
      if (element.nombre == emp.provinciaNacimiento) {
        this._crearEmpleado.getCantones(element.codigoProvincia.toString()).subscribe((respuesta) => {
          this.formulario.get('provincia').setValue(element.nombre);
          this.cmbCantones = respuesta;
          if (emp.ciudadDomicilio != undefined)
            this.cmbCantones.forEach(element => {
              console.log(emp.ciudadDomicilio);
              if (element.nombre == emp.ciudadDomicilio) {
                this.formulario.get('canton').setValue(emp.ciudadDomicilio);
              }
            });
        });
      }
    });
    this.formulario.get('tipoEmpleado').setValue(emp.tipoEmpleado);
    this.formulario.get('reportaA').setValue(emp.reportaA);
    this.mainCodigoCosto = this.findCmbGeneralValueCodigo(this.cmbCodigoCosto, emp.codCCosto);
    this.formulario.get('codCosto').setValue(this.mainCodigoCosto.descripcion);
    this.formulario.get('genero').setValue(emp.genero);
    this.formulario.get('regionDomi').setValue(emp.regionDomicilio);
    this.formulario.get('direccion').setValue(emp.direccionDomicilio);
    this.sendObject.cedula = emp.cedula;
    this.sendObject.claveUnica = emp.cedula;
    this.sendObject.codEmpleado = emp.codEmpleado;
    this.sendObject.codCCosto = emp.codCCosto;
    this.sendObject.codCargo = emp.codCargo;
    this.sendObject.codDepartamento = emp.codDepartamento;
    this.sendObject.email = emp.email;
    this.sendObject.codLocalidad = emp.codLocalidad;
    this.sendObject.dscaLocalidad = emp.dscaLocalidad
    this.sendObject.codCargo = emp.codCargo;
    this.sendObject.dscaCargo = emp.dscaCargo;
    this.sendObject.dscaDepartamento = emp.dscaDepartamento;
    this.sendObject.paisNacimiento = emp.paisNacimiento;
    this.sendObject.provinciaNacimiento = emp.provinciaNacimiento;
    this.sendObject.direccionDomicilio = emp.direccionDomicilio;
    this.sendObject.direccion = emp.direccionDomicilio;
    this.sendObject.genero = emp.genero;
    this.sendObject.loguedUser = this.loguedUser;
    if (!this.falsoPositivo) {
      this.formulario.get('nombres').disable();
    } else {
      this.formulario.get('nombres').enable();
    }
    //AGREGAR VALIDACION QUE SI NO PERTENCE A LA FABRIL SE PUEDA MODIFICAR EL NOMBRE
    // debugger
    if (emp.empresa.codEmpresa === this.codEmpresa.codEmpresa ) {
      this.formulario.get('nombres').disable();
    } else {
      this.formulario.get('nombres').enable();
    }
    if(emp.acceoIESS !== undefined) {
      this.isIES = emp.acceoIESS;
      this.formulario.get('IESS').setValue(this.isIES); //descomentar para la nueva version
    }
    this.formulario.get('motivoVisita').setValue((emp.motivoVisita === undefined)?'':emp.motivoVisita);
    setTimeout(() => {
      // this.changeEmpresaSolicita();
      this.selecionEmpresaSolicita();
      this.selecionDepartamentoSolicita();
    }, 600);
    //
    //this.formulario.get('localidad').disable();
    //this.formulario.get('areaTrabajo').disable();
    //this.formulario.get('pais').disable();
    //this.formulario.get('cedula').disable();
  }

 
  validarFechas() {
    let date = new Date('1900-12-03');
    if (new Date(this.formulario.get('fechaNacimiento').value) < date) {
      this._util.mensajeErrorVisto('La fecha de nacimiento debe ser mayor 1900');
      return true;
    }
    if (this.formulario.get('fechaPrimero').value !== undefined) {
      if (new Date(this.formulario.get('fechaPrimero').value) < date) {
        this._util.mensajeErrorVisto('La fecha de primer contrato debe ser mayor a 1900');
        return true;
      }
    }

    if (this.formulario.get('fechaUltimo').value !== undefined) {
      if (new Date(this.formulario.get('fechaUltimo').value) < date) {
        this._util.mensajeErrorVisto('La fecha del último contrato debe ser mayor a 1900');
        return true;
      }
    }
    if (new Date(this.formulario.get('fechaIngreso').value) < date) {
      this._util.mensajeErrorVisto('La fecha del primer ingreso debe ser mayor 1900');
      return true;
    }
    if (new Date(this.formulario.get('fechaSalida').value) < date) {
      this._util.mensajeErrorVisto('La fecha de la ultima salida debe ser mayor 1900');
      return true;
    }
    return false;
  }

  enviarFormulario() {
    if (this.validarFechas()) {
      return;
    }

    if (this.validaCedulaNacional(this.formulario.get('cedula').value)) {
      return;
    }

    this.sendObject.cedula = this.formulario.get('cedula').value;
    this.sendObject.claveUnica = this.formulario.get('cedula').value;
    this.sendObject.codEmpleado = this.formulario.get('cedula').value;
    //if(this.nuevoUsuario==1){   
    //  this.sendObject.claveUnica=this.formulario.get('cedula').value;
    //  this.sendObject.codEmpleado=this.formulario.get('cedula').value;
    //}
    if (this.mainCodigoCosto != undefined) {
      this.sendObject.codCCosto = this.mainCodigoCosto.codigo;
    }
    this.sendObject.codCargo = this.mainCargo.codigo;
    if (this.mainDepartamento != undefined) {
      this.sendObject.codDepartamento = this.mainDepartamento.codigo;
    }
    this.sendObject.codLocalidad = this.mainLocalidad.codigo;
    this.sendObject.direccion = this.formulario.get('direccion').value;
    this.sendObject.direccionDomicilio = this.formulario.get('direccion').value;
    this.sendObject.dscaCCosto = this.mainCodigoCosto.descripcion;
    this.sendObject.dscaCargo = this.mainCargo.descripcion;
    this.sendObject.dscaDepartamento = this.mainDepartamento.descripcion;
    this.sendObject.dscaLocalidad = this.mainLocalidad.descripcion;
    this.sendObject.email = this.formulario.get('email').value;
    this.sendObject.empresa = {};
    this.sendObject.empresa = this.mainEmpresa;
    this.sendObject.fechaNacimiento = this.formulario.get('fechaNacimiento').value;
    this.sendObject.fechaPrimerContrato = this.formulario.get('fechaPrimero').value;
    if (this.sendObject.fechaPrimerContrato === "") {
      this.sendObject.fechaPrimerContrato = null;
    }
    this.sendObject.fechaUltimoContrato = this.formulario.get('fechaUltimo').value;
    if (this.sendObject.fechaUltimoContrato === "") {
      this.sendObject.fechaUltimoContrato = null;
    }
    this.sendObject.genero = this.formulario.get('genero').value;
    this.sendObject.nombres = this.formulario.get('nombres').value;
    this.sendObject.paisNacimiento = this.formulario.get('pais').value;
    if (this.formulario.get('provincia').value != undefined) {
      this.sendObject.provinciaNacimiento = this.formulario.get('provincia').value;
    } else {
      this.sendObject.provinciaNacimiento = "NaN";
    }
    if (this.formulario.get('canton').value != undefined) {
      this.sendObject.ciudadDomicilio = this.formulario.get('canton').value;
    } else {
      this.sendObject.provinciaNacimiento = "NaN";
    }
    this.sendObject.regionDomicilio = this.formulario.get('regionDomi').value;
    this.sendObject.reportaA = this.formulario.get('reportaA').value;
    this.sendObject.telefono = this.formulario.get('telefono').value;
    this.sendObject.fechaIngreso = this.formulario.get('fechaIngreso').value;
    this.sendObject.fechaSalida = this.formulario.get('fechaSalida').value;
    this.sendObject.empresaSolicita = this.mainEmpresaSolicita.codEmpresa;
    if (this.mainDepartamentoSolicita != undefined) {
      this.sendObject.departamentoSolicita = this.mainDepartamentoSolicita.codigo;
    }else{
      this._util.mensajeErrorVisto('Por favor elija un departamento solicitante');
      return;
    }
    this.sendObject.empleadoSolicita = this.formulario.get('empleadoSolicita').value;
    this.sendObject.tipoEmpleado = this.formulario.get('tipoEmpleado').value;
    this.sendObject.statusEmpleado = "Activo";
    this.sendObject.loguedUser = this.loguedUser;
    this.sendObject.motivoVisita = this.formulario.get('motivoVisita').value;
    this.sendObject.documentoIess = this.formulario.get('documentoIess').value;
    console.log(this.sendObject);
    this._util.confirmarSincronoPromesaNormal(
      {
        title: this.empModulo.mensajes.guardarParada,
        text: '',
        action: this.empModulo.button.buttonsNombre.guardar,
        funcion: this._crearEmpleado.sendEmpleado(this.sendObject),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      debugger
      this.formulario.reset();
      //this.formulario.get('fechaNacimiento').setValue(this.obtenerFechaConversion(this.currentDate));
      this.formulario.get('fechaNacimiento').setValue('');
      this.formulario.get('pais').setValue('ECUADOR');
      this.formulario.get('cedula').enable();
      this.formulario.get('nombres').enable();
      // this.formulario.get('apellidos').enable();
      this.documentoIess = false;
      this.formulario.get('documentoIess').setValue(this.documentoIess);
      this.check = document.getElementById("documentoIess") as HTMLInputElement;
      this.check.checked = false;
      this.statusCheck = "";
      this.sendObject= {};
    }).catch((err) => {
      //this.mostrasDetalleParada = false;
      console.log('Error ' + err);
      if (err != undefined)
        if (err.error.message != undefined)
          this._util.mensajeErrorVisto(err.error.message);
    });
  }

  findCmbGeneralValueDesc(cmb: any, value: string) {
    let out: CaracteristicaModel = new CaracteristicaModel();
    cmb.forEach(element => {
      if (element.descripcion == value) {
        //console.log(element);
        out = element;
      }
    });
    return out;
  }

  findCmbGeneralValueCodigo(cmb: any, value: string) {
    let out: CaracteristicaModel = new CaracteristicaModel();
    cmb.forEach(element => {
      if (element.pk.codigo == value) {
        //console.log(element);
        out = element;
      }
    });
    return out;
  }
  findCmbGenericArray(cmb: any, value: string) {
    let out;
    cmb.forEach(element => {
      if (element.descripcion == value) {
        //console.log(element);
        out = element;
      }
    });
    return out;
  }

  obtenerFechaConversion(value: Date) {
    const mesTemp = value.getMonth() + 1;
    const mes = ('0' + mesTemp.toString()).slice(-2);
    const dia = ('0' + value.getDate().toString()).slice(-2);
    const hora = ('0' + value.getHours().toString()).slice(-2);
    const minuto = ('0' + value.getMinutes().toString()).slice(-2);
    const segundo = ('0' + value.getSeconds().toString()).slice(-2);
    const fechaStringActual = value.getFullYear() + '-' + mes + '-' + dia;
    return fechaStringActual;
  }

  changeEmpresaSolicita(){
    if(this.formulario.get('empresaSolicita').value === this.codEmpresa.descripcion){
      this.formulario.get('departamentoSolicita').setValidators([Validators.required]);
      this.formulario.get('empleadoSolicita').setValidators([Validators.required]);
      this.claseLabel = 'letrasDanger';
      this.depSolicita = 'Departamento Solicita*';
      this.empSolicitante = 'Empleado Solicitante*';
    } else {
      this.formulario.get('departamentoSolicita').clearValidators();
      this.formulario.get('empleadoSolicita').clearValidators();
      this.claseLabel = '';
      this.depSolicita = 'Departamento Solicita';
      this.empSolicitante = 'Empleado Solicitante';
    }
  }

  changeClearSolicitados(event) {
    this.formulario.get('departamentoSolicita').setValue('');
    this.formulario.get('empleadoSolicita').setValue('');
  }

  clearCmb(tag) {
    this.formulario.get(tag).setValue('');  
  }
  
  validaCedulaNacional(cedula:string){
    let longitud = cedula.length;
    let esNacional =  this.formulario.get('cedulaNacional').value;
    console.info("Es nacional " + esNacional + " y tiene longitud de "+ longitud);

    if(esNacional && longitud < 10){
      this._util.mensajeErrorVisto("Cédula debe constar de 10 digitos", true, 3000);
      return true;
    }
    return false;
  }

}